import { useSyncExternalStore } from 'react';

export type SlotTimingPreview = {
  offsetMinutes?: number;
  durationMinutes?: number;
};

type TimingMap = Map<string, SlotTimingPreview>;

let snapshot: TimingMap = new Map();
const listeners = new Set<() => void>();

const getSnapshot = () => snapshot;
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const setSnapshot = (next: TimingMap) => {
  snapshot = next;
  listeners.forEach((listener) => listener());
};

const clear = () => {
  if (snapshot.size === 0) return;
  setSnapshot(new Map());
};

export const slotTimingPreviewStore = {
  getSnapshot,
  subscribe,
  setSnapshot,
  clear,
};

export const useSlotTimingPreviewMap = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export const useSlotTimingPreview = (slotId?: string) => {
  const map = useSlotTimingPreviewMap();
  if (!slotId) return undefined;
  return map.get(slotId);
};
